import React, { useState, useEffect } from 'react'
import { createPortal } from 'react-dom'
import Image from 'next/image'
import { s3Static } from '../../utils/constants'

export const LoadingCover = () => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) return null

  return createPortal(
    <div className="flex justify-center items-center left-0 top-0 fixed z-60 w-full h-full backdrop-blur-sm bg-black/10">
          <div className="relative h-auto animate-pulse">
              <Image height={60} width={70} src={s3Static + "logo.png"} alt="StringsSg Logo"/>
          </div>
    </div>,
    document.body
  )
}
